module.exports = __webpack_public_path__ + "img/logomuni-color.177416b1.png";